import { mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import { scrollTo } from '../../../common/utilities/nojq/_scrollto.js';

export default {
    name: 'vmlslogo',
    components: {
        mvtDialogCenter,
        mvtHeader,
        mvtFooter,
    },
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        mlsData() {
            return this.glb.pageData;
        },
        logos() {
            return this.mlsData.logos || [];
        },
        logoIdList() {
            return Object.keys(this.mlsData.data || {});
        },
        imgUrl() {
            return this.glb.cdnUrl + 'images/desktop/logo/logo_';
        },
    },
    methods: {
        checkHashChange() {
            var hash = location.hash;
            if (hash) {
                scrollTo(hash.replace('#', ''));
            }
        },
        isMLSGridLogo(mlsId) {
            return this.mlsData.data[mlsId] && this.mlsData.data[mlsId].rule && this.mlsData.data[mlsId].rule.includes("showMLSGridLogo");
        },
    },
    mounted() {
        this.checkHashChange();
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
